import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import Swal from 'sweetalert2';
import { CModal } from '@coreui/react';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';

const SectionAnnouncementView = () => {
    const authorizedAxios = generateAxiosInstance()
    const [InstituteGradeList, setInstituteGradeList] = useState([])
    const [InstituteList, setInstituteList] = useState([])
    const [page, setPage] = useState(1)
    const [total, setTotal] = useState(300)
    const [refreshList, setRefreshList] = useState(false)
    const [limit, setLimit] = useState(100)
    const [visible, setVisible] = useState(false)
    const [modalData, setModalData] = useState('')
    const renderContent = () => {
        const items = [];
        console.log(page, total, Math.ceil(total / limit))
        for (let i = 1; i <= Math.ceil(total / limit); i++) {
            i >= page && i <= page + 3 && items.push(
                <div className={i === page ? 'circle-btn selected' : 'circle-btn'}>{i}</div>
            );
        }
        return items;
    }

    const instituteMasterId = localStorage.getItem("instituteMasterId")
    const sectionMasterId = localStorage.getItem("sectionMasterId")
    const authorizedAxiosSection = generateAxiosInstanceSection()

    useEffect(() => {
        let apiUrl = `/get-section-announcement?sectionMasterId=${sectionMasterId}&instituteMasterId=${instituteMasterId}`
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setInstituteGradeList(response.data.result);
                setTotal(response.data.result.total)
            })
            .catch(error => {
                setInstituteGradeList(error?.response?.data.result);
            });

    }, [limit, page, refreshList]); 

  



    return (
        <>
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item">
                                <span>Home</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Section Announcement </span></li>
                        </ol>
                    </nav>
                </div>
                <CModal
                    visible={modalData!==''}
                    onClose={() => setModalData('')}
                    aria-labelledby="LiveDemoExampleLabel"
                    
                >
                     <div className='announcement-div'>
                     <div class="icon"><i class="fa fa-bullhorn"></i></div>
                      <h2 >{modalData?.title}</h2>

                      <p className='announcement-p'>{modalData?.content}</p>

                        <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setModalData('')}>
                            Close
                        </button>
                    </div>

                </CModal>

                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span>Section Announcement </b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                            </div>
                                            <div className="row">
                                                <div className='custom-pagintation'>
                                                    <div className='left-info'>
                                                        <h5>Results</h5>
                                                        <select onChange={(e) => setPage(e.target.value)} className='pageNo'>
                                                            <option value={10}>10</option>
                                                            <option selected value={100}>100</option>
                                                            <option value={200}>200</option>
                                                        </select>
                                                    </div>
                                                    <div className='right-info'>
                                                        <button className='nextPrevBtn first' disabled={page <= 1} onClick={() => setPage(page - 1)}>
                                                            <i class="fa fa-chevron-left" aria-hidden="true"></i>
                                                        </button>
                                                        {renderContent()}
                                                        <button className='nextPrevBtn last' disabled={total / limit < page} onClick={() => setPage(page + 1)}>
                                                            <i class="fa fa-chevron-right" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">Title</th>
                                                                        <th scope="col">Announcement</th>
                                                                        <th scope='col'>Created By</th>
                                                                        <th scope='col'>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        InstituteGradeList?.length > 0 ?
                                                                            InstituteGradeList?.map((std, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{index + 1}</th>
                                                                                        <td>{std.title}</td>
                                                                                        <td>{std.content}</td>
                                                                                        <td>{std.instituteMasterId == null && std.sectionMasterId == null ? "Admin" : std.sectionMasterId == null ? std.instituteMasterDetails.instituteName : `${std.instituteMasterDetails.instituteName}/${std.sectionMasterDetails.sectionName}` }</td>

                                                                                        <td>
                                                                                            <button className='btn btn-success approve_icon' onClick={()=>setModalData(std)} >View</button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Announcement Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default SectionAnnouncementView
